import { WSkeleton, WStack } from '../../wrappers/wrapper';
import style from './user-posts-skeleton.module.scss';

const UserPostsSkeleton = () => {
  return (
    <WStack className={style.postCard}>
      <WStack spacing={1.5}>
        <WStack direction={'row'} spacing={1.2} alignItems={'center'}>
          <WSkeleton animation="wave" variant="rounded" width={40} height={40} />
          <WSkeleton animation="wave" variant="text" width={60} height={22} />
          <WSkeleton animation="wave" variant="text" width={50} height={20} />
        </WStack>
        <WSkeleton animation="wave" variant="rounded" width={'auto'} height={250} />
        <WStack>
          <WSkeleton animation="wave" variant="text" width={240} height={40} />
          <WSkeleton animation="wave" variant="text" width={200} height={25} />
        </WStack>

        <WStack justifyContent={'space-between'} direction={'row'}>
          <WSkeleton animation="wave" variant="rounded" width={55} height={45} />
          <WSkeleton animation="wave" variant="rounded" width={55} height={45} />
        </WStack>
      </WStack>
    </WStack>
  );
};

export default UserPostsSkeleton;
